import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const ModalInfo = props => {
  const {modal, closeModal, showFooter, textBody, title } = props;


  return (
    <div>
      <Modal isOpen={modal} toggle={()=> closeModal()}>
        <ModalHeader toggle={()=> closeModal()}>{title}</ModalHeader>
        <ModalBody className="modal-info">
          {textBody}
        </ModalBody>
        {showFooter && (
          <ModalFooter>
            <Button color="secondary" onClick={()=> closeModal()}>
              Cerrar
            </Button>
          </ModalFooter>
        )}
      </Modal>
    </div>
  );
};
export default ModalInfo;
